export default "__VITE_ASSET__20f21eb7__"